import s from "../conference-settings-modal.module.scss";

const LEVEL_SEGMENTS = 10;

export const AudioLevelMeter = ({
  level = 0,
  status = "idle",
  idleLabel,
  activeLabel,
  errorLabel,
}) => {
  // const caption = status === "error" ? errorLabel : status === "active" ? activeLabel : idleLabel;

  return (
    <div className={s.levelMeter}>
      <div className={s.levelBars} aria-hidden="true">
        {Array.from({ length: LEVEL_SEGMENTS }, (_, index) => {
          const threshold = (index + 1) / LEVEL_SEGMENTS;
          const isRaised = level >= threshold;
          const zoneClass =
            index < 6 ? s.levelBarGreen : index < 8 ? s.levelBarYellow : s.levelBarRed;

          return (
            <span
              key={`level-bar-${index}`}
              className={`${s.levelBar} ${
                isRaised ? s.levelBarActive : ""
              } ${zoneClass} ${status === "error" ? s.levelBarError : ""}`.trim()}
            />
          );
        })}
      </div>
      {/* <div className={s.levelMeterCaption}>{caption}</div> */}
    </div>
  );
};
